import React from 'react'
import Empty from '../feedback/Empty'

function NurseFinances({userObject}) {
    return (
        <div className='space-y-4'>
            <p className='font-bold text-lg'>{userObject?.user?.role} Finances</p>
            <Empty objectName={`${userObject?.user?.role} Finances`}/>
        </div>
    )
}

export default NurseFinances